import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getComponentProps} from './Outcome.selector';

function mapStateToProps(state, ownProps) {
  return getComponentProps(state, ownProps);
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Outcome = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.Outcome);
